import { useMemo } from 'react';
import { parseJSON } from '@ywwwtseng/ywjs';
import { useQueryState } from '@ywwwtseng/react-kit';
import type { SelectTgChat } from '@/types';


export function useChat(id?: string | null) {
  const state = useQueryState<{ [key: string]: SelectTgChat[] }>();

  return useMemo(() => {
    const keys = Object.keys(state ?? {});

    for (const key of keys) {
      const parsed = parseJSON(key);

      if (parsed && typeof parsed === 'object' && 'path' in parsed && parsed.path === 'allowed_gift_chats') {
        const chats = state?.[key] as SelectTgChat[];
        return chats.find((chat) => chat.id === id);
      }
    }

    return undefined;
  }, [state, id]);
}